import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { all_routes } from '../../../router/all_routes'

const Experienced = () => {
    const route = all_routes
    return (
        <>
            {/* Experienced Course Five */}
            <section className="experienced-course-five">
                <div className="container">
                    <div className="row align-items-center">
                        {/* <div className="col-lg-6" data-aos="fade-down">
                            <div className="experienced-five-group">
                                <div className="instructor-vector-left">
                                    <ImageWithBasePath src="assets/img/bg/instructor-vector-left.svg" alt="Img" />
                                </div>
                                <div className="developer-five-list">
                                    <ul>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-01.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-02.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-03.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-04.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-05.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-06.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-07.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-08.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-09.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-10.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-11.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-12.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-13.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-14.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-15.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="column-img">
                                            <div className="developer-profile-five">
                                                <div className="developer-image">
                                                    <ImageWithBasePath
                                                        src="assets/img/user/user-16.jpg"
                                                        alt="Course Instructor"
                                                    />
                                                </div>
                                                <div className="profile-five-ovelay">
                                                    <h5>Daziy Millar</h5>
                                                    <p>PHP Expert</p>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="instructor-vector-right">
                                    <ImageWithBasePath src="assets/img/bg/instructor-vector-right.svg" alt="Img" />
                                </div>
                            </div>
                        </div> */}
                        <div className="col-lg-6 col-sm-12" data-aos="fade-down">
                            <div className="joing-count-five text-center">
                                <div className="joing-count-image">
                                    <ImageWithBasePath src="assets/img/instructor/instructor-03.png" alt="Img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-down">
                            <div className="experienced-five-sub">
                                <div className="header-five-title header-five-title-inner">
                                    <p className='text-white'>RECRUITMENT PARTNERS</p>
                                    <h2 className="ex-five-title">How We Empower Recruitment Partners</h2>
                                </div>
                                <div className="career-five-content">
                                    <ul className="ex-five-content">
                                        
                                            <li>Gain access to over 140,000 programs across 1,500+ leading academic institutions to offer your students unmatched choices.</li>

                                            <li>Leverage AI-powered tools designed to help you achieve a 95% application success rate and close more placements.</li>

                                            <li>Enhance your student support services with built-in resources, including language test prep and student loan options.</li>
                                        
                                    </ul>
                                </div>
                                <Link to={route.recruiterHome} className="btn btn-secondary btn-md">
                                    Join Now
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Experienced Course Five */}
        </>

    )
}

export default Experienced
